import type { Editor } from "grapesjs";

export const panelConfigViews = (editor: Editor) => {
  editor.Panels.removeButton("views", "open-sm");
  editor.Panels.removeButton("views", "open-tm");
  editor.Panels.removeButton("views", "open-layers");
  editor.Panels.removeButton("views", "open-blocks");

  const viewsPanel = editor.Panels.getPanel("views");
  if (viewsPanel) {
    editor.Panels.removePanel("views");
  }

  setTimeout(() => {
    const viewsContainer = document.querySelector(".gjs-pn-views-container");
    if (viewsContainer) {
      viewsContainer.remove();
    }

    const pnPanel = document.querySelector(".gjs-pn-panel.gjs-pn-views");
    if (pnPanel) {
      pnPanel.remove();
    }
  }, 50);
};
